// package: user.base
// file: user/base/model.proto


export const UserInfoPublicV2 = {
    encode(object) {
        const message = {};
        if (object.ID != null) {
            if (object.ID !== "") {
                message.ID = String(object.ID);
            }
        }
        if (object.userNum != null) {
            if (object.userNum !== "") {
                message.userNum = String(object.userNum);
            }
        }
        if (object.nickname != null) {
            if (object.nickname !== "") {
                message.nickname = String(object.nickname);
            }
        }
        if (object.avatar != null) {
            if (object.avatar !== "") {
                message.avatar = String(object.avatar);
            }
        }
        if (object.character != null) {
            if (object.character !== 0) {
                message.character = object.character;
            }
        }
        if (object.channel != null) {
            if (object.channel !== "") {
                message.channel = String(object.channel);
            }
        }
        return message;
    },

    decode(message) {
        const object = {
            ID: "",
            userNum: "",
            nickname: "",
            avatar: "",
            character: 0,
            channel: "",
        };

        if (message.ID != null) {
            object.ID = message.ID;
        }
        if (message.userNum != null) {
            object.userNum = message.userNum;
        }
        if (message.nickname != null) {
            object.nickname = message.nickname;
        }
        if (message.avatar != null) {
            object.avatar = message.avatar;
        }
        if (message.character != null) {
            object.character = message.character;
        }
        if (message.channel != null) {
            object.channel = message.channel;
        }
        return object;
    },
};

export const RefundOrderRiskControl = {
    encode(object) {
        const message = {};
        if (object.switch != null) {
            if (object.switch !== false) {
                message.switch = Boolean(object.switch);
            }
        }
        if (object.refundOrderStartTime != null) {
            if (object.refundOrderStartTime !== 0) {
                message.refundOrderStartTime = String(object.refundOrderStartTime);
            }
        }
        if (object.orderStartTime != null) {
            if (object.orderStartTime !== 0) {
                message.orderStartTime = String(object.orderStartTime);
            }
        }
        return message;
    },

    decode(message) {
        const object = {
            switch: false,
            refundOrderStartTime: 0,
            orderStartTime: 0,
        };

        if (message.switch != null) {
            object.switch = message.switch;
        }
        if (message.refundOrderStartTime != null) {
            object.refundOrderStartTime = parseInt(message.refundOrderStartTime, 10);
        }
        if (message.orderStartTime != null) {
            object.orderStartTime = parseInt(message.orderStartTime, 10);
        }
        return object;
    },
};

export const UserAttrsV2 = {
    encode(object) {
        const message = {};
        if (object.signInPushSwitch != null) {
            if (object.signInPushSwitch !== 0) {
                message.signInPushSwitch = object.signInPushSwitch;
            }
        }
        if (object.oneYuanPhoneSeckillSwitch != null) {
            if (object.oneYuanPhoneSeckillSwitch !== 0) {
                message.oneYuanPhoneSeckillSwitch = object.oneYuanPhoneSeckillSwitch;
            }
        }
        if (object.blockPersonalizedPush != null) {
            if (object.blockPersonalizedPush !== false) {
                message.blockPersonalizedPush = Boolean(object.blockPersonalizedPush);
            }
        }
        if (object.blockAutoReadClipboard != null) {
            if (object.blockAutoReadClipboard !== false) {
                message.blockAutoReadClipboard = Boolean(object.blockAutoReadClipboard);
            }
        }
        if (object.hasEverJumpedToTaobaoTejiaViaGoshop != null) {
            if (object.hasEverJumpedToTaobaoTejiaViaGoshop !== false) {
                message.hasEverJumpedToTaobaoTejiaViaGoshop = Boolean(object.hasEverJumpedToTaobaoTejiaViaGoshop);
            }
        }
        if (object.hasEverFinishedWatchingRewardedVideo != null) {
            if (object.hasEverFinishedWatchingRewardedVideo !== false) {
                message.hasEverFinishedWatchingRewardedVideo = Boolean(object.hasEverFinishedWatchingRewardedVideo);
            }
        }
        if (object.refundOrderRiskControl != null) {
            message.refundOrderRiskControl = RefundOrderRiskControl.encode(object.refundOrderRiskControl);
        }
        return message;
    },

    decode(message) {
        const object = {
            signInPushSwitch: 0,
            oneYuanPhoneSeckillSwitch: 0,
            blockPersonalizedPush: false,
            blockAutoReadClipboard: false,
            hasEverJumpedToTaobaoTejiaViaGoshop: false,
            hasEverFinishedWatchingRewardedVideo: false,
            refundOrderRiskControl: null,
        };

        if (message.signInPushSwitch != null) {
            object.signInPushSwitch = message.signInPushSwitch;
        }
        if (message.oneYuanPhoneSeckillSwitch != null) {
            object.oneYuanPhoneSeckillSwitch = message.oneYuanPhoneSeckillSwitch;
        }
        if (message.blockPersonalizedPush != null) {
            object.blockPersonalizedPush = message.blockPersonalizedPush;
        }
        if (message.blockAutoReadClipboard != null) {
            object.blockAutoReadClipboard = message.blockAutoReadClipboard;
        }
        if (message.hasEverJumpedToTaobaoTejiaViaGoshop != null) {
            object.hasEverJumpedToTaobaoTejiaViaGoshop = message.hasEverJumpedToTaobaoTejiaViaGoshop;
        }
        if (message.hasEverFinishedWatchingRewardedVideo != null) {
            object.hasEverFinishedWatchingRewardedVideo = message.hasEverFinishedWatchingRewardedVideo;
        }
        if (message.refundOrderRiskControl != null) {
            object.refundOrderRiskControl = RefundOrderRiskControl.decode(message.refundOrderRiskControl);
        }
        return object;
    },
};


export const Character = {
    CHARACTER_UNDEFINED: 0,
    CHARACTER_BEAUTY: 1,
    CHARACTER_GUY: 2,
    CHARACTER_YOUNG_MOTHER: 3,
};


export const Gender = {
    GENDER_UNDEFINED: 0,
    GENDER_MALE: 1,
    GENDER_FEMALE: 2,
    GENDER_UNKNOWN: 3,
};


export const Status = {
    STATUS_UNDEFINED: 0,
    STATUS_OK: 1,
    STATUS_WROTE_OFF: 2,
    STATUS_SUSPECTED: 3,
};


export const UserAttrsSignInPushSwitch = {
    USER_ATTRS_SIGN_IN_PUSH_SWITCH_UNDEFINED: 0,
    USER_ATTRS_SIGN_IN_PUSH_SWITCH_ON: 1,
    USER_ATTRS_SIGN_IN_PUSH_SWITCH_OFF: 2,
};


export const UserAttrsOneYuanPhoneSeckillSwitch = {
    USER_ATTRS_ONE_YUAN_PHONE_SECKILL_SWITCH_UNDEFINED: 0,
    USER_ATTRS_ONE_YUAN_PHONE_SECKILL_SWITCH_ON: 1,
    USER_ATTRS_ONE_YUAN_PHONE_SECKILL_SWITCH_OFF: 2,
};


export const UserTokenType = {
    USER_TOKEN_TYPE_UNDEFINED: 0,
    USER_TOKEN_TYPE_LEGACY: 1,
    USER_TOKEN_TYPE_BIND_TAOBAO: 2,
    USER_TOKEN_TYPE_XIANWAN_GAME: 3,
};


export const VerificationSMSType = {
    VERIFICATION_SMS_TYPE_UNDEFINED: 0,
    VERIFICATION_SMS_TYPE_REGISTER: 1,
    VERIFICATION_SMS_TYPE_UPDATE_PHONE: 2,
};


export const Permission = {
    PERMISSION_UNDEFINED: 0,
    PERMISSION_WITHDRAW: 1,
    PERMISSION_PUSH_STREAM: 2,
};


